angular.module('eficienciaFiscalModule')
    .constant('uiDateConfig', {
        uiMask: '99/99/9999',
        placeholder: 'dd/mm/aaaa',
        changeYear: true,
        changeMonth: true,
        closeText: 'Fechar',
        prevText: '<i class="fa fa-chevron-left"></i>',
        nextText: '<i class="fa fa-chevron-right"></i>',
        currentText: 'Hoje',
        monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        dayNames: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
        dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        weekHeader: 'Sm',
        dateFormat: 'dd/mm/yy',
        firstDay: 0,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ''
    })
    .directive('uiDate', ['uiDateConfig', '$filter', function (uiDateConfig, $filter) {
        'use strict';
        var options;
        options = {};
        angular.extend(options, uiDateConfig);
        return {
            require: '?ngModel',
            replace: true,
            priority: 2000,
            template: '<input ui-mask="' + options.uiMask + '" ui-mask-return="true" ui-mask-initial-mask="false" placeholder="' + options.placeholder + '"/>',
            link: function (scope, element, attrs, controller) {
                var getOptions = function () {
                    return angular.extend({}, uiDateConfig, scope.$eval(attrs.uiDate));
                };

                scope.$watch(getOptions, function (opts) {
                    if (element.data('datepicker')) {
                        // Updates the datepicker options
                        element.datepicker('option', opts);
                        element.datepicker('refresh');
                    } else {
                        // Creates the new datepicker widget
                        element.datepicker(opts);

                        //Cleanup on destroy, prevent memory leaking
                        element.on('$destroy', function () {
                            element.datepicker('destroy');
                        });
                    }
                }, true);

                controller.$parsers.push(function (value) {
                    var regex = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/m;

                    if (regex.test(value)) {
                        return jQuery.datepicker.parseDate(getOptions().dateFormat, value);
                    } else {
                        if (value != '') {
                            controller.$setViewValue('');
                            controller.$render();
                        }

                        return '';
                    }
                });

                controller.$formatters.push(function (value) {
                    return $filter('date')(value, 'dd/MM/yyyy');
                });
            }
        };
    }
    ]);
